import React, { useContext } from 'react';
import { EditorHotbarContext } from './EditorHotbar';

interface MapItemSelectorProps {
    button: React.ReactNode
    popup: React.ReactNode
    id: string
}

const MapItemSelector = (props: MapItemSelectorProps) => {
    const { setActiveElement, id } = useContext(EditorHotbarContext);

    const handleClick = () => {
        setActiveElement(props.id, (
            <>
                {props.popup}
            </>
        ));
    };

    return (
        <>
            <div
                className={
                    'flex items-center cursor-pointer justify-center h-24 min-w-24'
                    + ` ${id === props.id ? 'bg-mid-blue' : ''}`}
                onClick={handleClick}
            >
                {props.button}
            </div>
        </>
    );
};


export default MapItemSelector;
